<template>
  <div>
    <product-form v-if="product"
      @submit="submit"
      @submitAndNew="submitAndNew"
      @addComment="addComment"
      @deleteComment="deleteComment"
      :init-product="product"
      :custom-categories="customCategories"
      :val-errors="valErrors"
      submit-text="Erstellen"
    />
    <assign-to-supplier-dialog v-if="createdProduct"
      :show="showSupplierDialog"
      :suppliers="suppliers"
      @assignToSupplier="assignToSupplier"
      @close="closeSupplierDialog"
      :val-errors="assignErrors"
      :init-price="createdProduct.standard_price || ''"
    />
  </div>
</template>

<script>
import ProductForm from './product-form'
import AssignToSupplierDialog from './assign-to-supplier-dialog'
import swal from 'sweetalert2'
import moment from 'moment'
import uniqueId from 'lodash/uniqueId'

export default {
  components: { ProductForm, AssignToSupplierDialog },
  data () {
    return {
      suppliers: [],
      customCategories: [],
      valErrors: [],
      product: null,
      showSupplierDialog: false,
      createdProduct: null,
      assignErrors: []
    }
  },
  methods: {
    async submit (product, redirect = true) {
      await this.initCsrf()

      this.valErrors = []
      this.$http.post('products', product).then(({ data }) => {
        this.createdProduct = data
        this.$notify({
          message: 'Produkt erfolgreich erstellt.',
          type: 'success'
        })
        if (redirect) {
          this.showAlert()
        } else {
          product.name = null
        }
      }).catch(({ response }) => { this.valErrors = response.data.errors })
    },
    submitAndNew (product) {
      this.submit(product, false)
    },
    addComment (comment) {
      this.product.info_highlights.unshift({
        id: uniqueId(),
        comment,
        user: this.$store.state.authUser,
        created_at: moment()
      })
    },
    deleteComment (comment) {
      const index = this.product.info_highlights.findIndex(({ id }) => id === comment.id)
      this.product.info_highlights.splice(index, 1)
    },
    showAlert (createdSupplier) {
      swal.fire({
        title: 'Lieferant',
        html: 'Wollen Sie jetzt das Produkt einem Lieferanten zuweisen?',
        confirmButtonText: 'Ja bitte!',
        showCancelButton: true,
        cancelButtonText: 'Nein danke!',
        timer: 10000,
        timerProgressBar: true,
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-lg btn-fill btn-info',
        cancelButtonClass: 'btn btn-lg btn-fill btn-default'
      }).then((result) => {
        if (result.value === true) {
          this.showSupplierDialog = true
        } else {
          this.$router.push('/products')
        }
      })
    },
    async assignToSupplier (payload) {
      await this.initCsrf()

      const url = `/suppliers/${payload.supplier_id}/products/${this.createdProduct.id}`
      this.$http.post(url, { price: payload.price }).then(({ data }) => {
        this.$notify({
          message: 'Produkt erfolgreich dem Lieferanten zugewiesen.',
          type: 'success'
        })
        this.closeSupplierDialog()
      }).catch(({ response }) => { this.assignErrors = response.data.errors })
    },
    closeSupplierDialog () {
      this.showSupplierDialog = false
      this.$router.push('/products')
    },
    getInitProduct () {
      return {
        price: '',
        standard_price: '',
        pictures: [],
        info_highlights: [],
        product_features: [],
        tax: 0.2,
        is_for_webshop: true,
        has_variations: false
      }
    }
  },
  created () {
    if (this.$route.query.warehouse) {
      this.$http.get(`/warehouses/${this.$route.query.warehouse}`).then(({ data }) => {
        this.product.warehouse = data
      })
    }

    this.$http.get('/custom_categories').then(({ data }) => {
      this.customCategories = data
      this.product.product_features = data.reduce((sum, customCategory) => {
        const feature = customCategory.features.find((feature) => feature.product_default)

        sum[customCategory.id] = {
          custom_category_id: customCategory.id,
          feature_id: feature ? feature.id : null,
          feature: feature || null,
          feature_option_id: null,
          feature_option: null,
          feature_options: null,
          feature_option_value: null,
          create_variations: feature ? feature.create_variations : false
        }
        return sum
      }, {})
    })

    this.product = this.getInitProduct()

    this.$http.get('/suppliers').then(({ data }) => {
      this.suppliers = data
    })
  }
}
</script>

<style>
</style>
